<mat-toolbar>
  <div class="md-toolbar-tools">
    <h1 mat-dialog-title>Carregue um Arquivo</h1>
    <span flex></span>
    <div class="posicionar-direita">
      <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
        <mat-icon>fullscreen_exit</mat-icon>
      </button>
      <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
        <mat-icon>fullscreen</mat-icon>
      </button>
      <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>
<mat-dialog-content>
  <div class="descricao">
    <p>Selecione um arquivo .ofx:</p>
  </div>
  <br>
  <div class="custom-upload">
    <input class="file-input" type="file" accept=".ofx" (change)="selecionarArquivo($event)" #fileUploader/>
    <button mat-raised-button class="upload-btn"
    (click)="fileUploader.click()">
      <mat-icon>attach_file</mat-icon>
      Escolher arquivo
    </button>
    <div>
      <p *ngIf="nomeArquivo">Arquivo selecionado: {{ nomeArquivo }}</p>
      <p *ngIf="!nomeArquivo">Arquivo selecionado: nenhum</p>
    </div>
  </div>
</mat-dialog-content>
<div class="descricao">
  <p style="font-weight: bold;">
    ⚠️ Importante: O arquivo .ofx deve conter apenas transações financeiras. O arquivo não pode conter os saldos.
  </p>
</div>
<br>
<mat-dialog-actions align="end">
  <button mat-button (click)="fechar()">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="!arquivoSelecionado" (click)="confirmar()">
    Confirmar
  </button>
</mat-dialog-actions>
